import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Send, AlertCircle, Loader } from "lucide-react";
import { API_URL, API_URL_UPLOADS } from "../components/config";
import Modal1 from "./Modal"; // Import the modal component
import FileAttachment from "./AttachFile";
import Modal from "react-modal";

const customStyles = `
  .neu-card {
    background: #fff;
    border-radius: 1.5rem;
    box-shadow: 0 6px 32px 0 rgba(0,0,0,0.06), 0 1.5px 4px 0 rgba(0,0,0,0.06);
    transition: box-shadow .15s;
    padding: 2rem;
    margin-bottom: 2rem;
  }
  .neu-card:focus-within {
    box-shadow: 0 8px 40px 0 rgba(0,41,102,0.09), 0 2px 8px 0 #00296633;
  }
  .accent {
    color: #002966;
  }
  .accent-bg {
    background: #002966;
    color: #fff;
  }
  .accent-border {
    border-color: #002966 !important;
  }
  .input-accent:focus, .input-accent:active {
    border-color: #002966 !important;
    box-shadow: 0 0 0 2px #00296633;
    outline: none;
  }
  .disabled {
    background: #f7f7f7 !important;
    color: #ccc !important;
    cursor: not-allowed !important;
    pointer-events: none;
  }
  .step-indicator {
    display: flex;
    gap: 1.5rem;
    justify-content: center;
    margin-bottom: 2rem;
  }
  .step {
    position: relative;
    font-weight: 600;
    letter-spacing: .02em;
    color: #b0b0b0;
    transition: color .2s;
  }
  .step.active {
    color: #002966;
  }
  .step:not(:last-child):after {
    content: '';
    display: inline-block;
    margin-left: 1rem;
    margin-right: 1rem;
    width: 24px;
    height: 2px;
    background: #e3e3e3;
    vertical-align: middle;
  }
  .step.active:not(:last-child):after {
    background: #002966;
  }
  .chat-id-pill {
    background: #e9f1fb;
    color: #002966;
    font-weight: 600;
    border-radius: 999px;
    padding: .3em 1em;
    font-size: .93em;
    display: inline-block;
    margin-bottom: 1em;
    letter-spacing: .01em;
    box-shadow: 0 1px 2px 0 #00296622;
  }
     .neu-card {
    background: #fff;
    border-radius: 1.5rem;
    box-shadow: 0 6px 32px 0 rgba(0,0,0,0.06), 0 1.5px 4px 0 rgba(0,0,0,0.06);
    transition: box-shadow .15s;
    padding: 2rem;
    margin-bottom: 2rem;
  }
  .modal {
    background: white;
    padding: 20px;
    border-radius: 10px;
    max-width: 500px;
    margin: auto;
    position: relative; /* Adjusted for positioning */
  }
  .overlay {
    background: rgba(0, 0, 0, 0.7);
    position: fixed; /* Make it fixed */
    top: 0; /* Cover the entire viewport */
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .accent {
    color: #002966;
  }
  .accent-bg {
    background: #002966;
    color: #fff;
  }
  .input-accent:focus, .input-accent:active {
    border-color: #002966 !important;
    box-shadow: 0 0 0 2px #00296633;
    outline: none;
  }
`;
const MessagingSection = ({ id, adminId, customerId }) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [error, setError] = useState(null);
  const [isTyping, setIsTyping] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentMediaUrl, setCurrentMediaUrl] = useState(null);
  const messagesEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const toggleModal1 = () => {
    setIsModalOpen1(!isModalOpen1);
  };
  const fetchMessages = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/clientservicechat/getchatsbychatid/${id}`
      );
      setMessages(response.data);
      setTimeout(scrollToBottom, 100);
    } catch (err) {
      setError("Failed to fetch messages.");
    }
  };

  const handleReply = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;

    setIsTyping(true);
    const dateChat = new Date().toISOString().split("T")[0];
    const timeChat = new Date().toLocaleTimeString();

    try {
      await axios.post(`${API_URL}/customer_admin_chats`, {
        customer_driver_chat_id: null,
        date_chat: dateChat,
        time_chat: timeChat,
        trip_id: "0",
        admin_id: adminId,
        driver_id: customerId,
        message: newMessage,
        conversation_id: id,
        origin: adminId,
      });

      setNewMessage("");
      fetchMessages();
    } catch (err) {
      setError("Failed to send your message.");
    } finally {
      setIsTyping(false);
    }
  };

  useEffect(() => {
    fetchMessages();
    const interval = setInterval(fetchMessages, 5000); // Poll every 5 seconds
    return () => clearInterval(interval);
  }, [id]);

  const formatTime = (dateStr, timeStr) => {
    const date = new Date(dateStr + " " + timeStr);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  const handleMediaClick = (mediaUrl) => {
    setCurrentMediaUrl(`${API_URL_UPLOADS}/${mediaUrl}`);
    setIsModalOpen(true);
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      className="w-1/3 flex flex-col h-screen bg-gray-50"
    >
      <style>{customStyles}</style>
      {/* Header */}
      <div className="bg-[#002966] p-4 text-white shadow-lg">
        <h2 className="text-xl font-semibold">Conversation</h2>
        {isTyping && (
          <div className="text-sm text-[#ffc000] flex items-center gap-2 mt-1">
            <Loader className="w-4 h-4 animate-spin" />
            Sending message...
          </div>
        )}
      </div>

      {/* Error Message */}
      {error && (
        <div className="bg-red-50 p-3 m-4 rounded-lg flex items-center gap-2 text-red-600">
          <AlertCircle className="w-5 h-5" />
          {error}
        </div>
      )}

      {/* Messages Container */}
      <div
        ref={chatContainerRef}
        className="flex-1 overflow-y-auto p-4 space-y-4"
        style={{
          backgroundImage: `radial-gradient(circle at center, #f0f4f8 0%, #e1e8f0 100%)`,
        }}
      >
        {messages.map((msg, index) => (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            key={index}
            className={`flex ${
              msg.origin === adminId ? "justify-end" : "justify-start"
            }`}
          >
            <div
              className={`max-w-[80%] rounded-lg p-3 shadow-sm ${
                msg.origin === adminId
                  ? "bg-[#002966] text-white rounded-br-none"
                  : "bg-white rounded-bl-none"
              }`}
            >
              <p className="text-sm">{msg.message}</p>
              {msg.message_type === "multimedia" && (
                <button
                  onClick={() => handleMediaClick(msg.media_url)}
                  className="text-blue-500 underline mt-1"
                >
                  Open Attachment
                </button>
              )}
              <div
                className={`text-xs mt-1 ${
                  msg.origin === adminId ? "text-[#ffc000]" : "text-gray-500"
                }`}
              >
                {formatTime(msg.date_chat, msg.time_chat)} @ {msg.origin}
              </div>
            </div>
          </motion.div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      {/* Message Input */}
      <div className="p-4 bg-white shadow-lg">
        <form onSubmit={handleReply} className="flex gap-2">
          <input
            type="text"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder="Type your message..."
            className="flex-1 p-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-[#ffc000] focus:border-transparent outline-none transition-all duration-200"
          />
          <button
            onClick={toggleModal1}
            className="bg-[#002966] text-white rounded-lg px-6 py-2 hover:bg-[#001f4d] transition-colors duration-200 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Attach File
          </button>
          <button
            type="submit"
            disabled={isTyping}
            className="bg-[#002966] text-white rounded-lg px-6 py-2 hover:bg-[#001f4d] transition-colors duration-200 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Send className="w-5 h-5" />
            Send
          </button>
        </form>
      </div>
      <Modal
        isOpen={isModalOpen1}
        onRequestClose={toggleModal1}
        contentLabel="Attach File Modal"
        className="modal"
        overlayClassName="overlay"
      >
        <h2 className="text-2xl font-bold">Attach a File</h2>
        <FileAttachment
          userId={localStorage.getItem("adminId")}
          reciever={customerId}
          chatId={id} // Replace with the actual username
          onMessageSend={() => {
            // Handle message sending after file attachment
            toggleModal1();
          }}
        />
        <button onClick={toggleModal1} className="mt-4 accent-bg">
          Close
        </button>
      </Modal>
      {/* Modal for Media */}
      <Modal1
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        mediaUrl={currentMediaUrl}
      />
    </motion.div>
  );
};

export default MessagingSection;
